import { adminService } from '@/api/services';
import type { UnwrapData } from '@/api/types';

import type { IAdvantagesResponse, IMoveAdvantageResponse, TAdvantagePayload } from './types';

export const advantagesService = adminService.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Получить преимущества
     */
    getAdvantages: builder.query<UnwrapData<IAdvantagesResponse>, { id: number }>({
      query: ({ id }) => ({
        method: 'GET',
        url: `/main_pages/${id}/advantages`,
      }),
      transformResponse: (response: IAdvantagesResponse): UnwrapData<IAdvantagesResponse> => response.data,
      providesTags: ['MainPageAdvantages'],
    }),
    /**
     * Создать преимущество
     */
    createAdvantage: builder.mutation<UnwrapData<IAdvantagesResponse>, { id: number; data: TAdvantagePayload }>({
      query: ({ id, data }) => ({
        method: 'POST',
        url: `/main_pages/${id}/advantages`,
        body: {
          data,
        },
      }),
      transformResponse: (response: IAdvantagesResponse): UnwrapData<IAdvantagesResponse> => response.data,
      invalidatesTags: ['MainPage', 'MainPageAdvantages'],
    }),
    /**
     * Изменить преимущество
     */
    updateAdvantage: builder.mutation<
      UnwrapData<IAdvantagesResponse>,
      { mainPageId: number; advantageId: number; data: TAdvantagePayload }
    >({
      query: ({ mainPageId, advantageId, data }) => ({
        method: 'PATCH',
        url: `/main_pages/${mainPageId}/advantages/${advantageId}`,
        body: {
          data,
        },
      }),
      transformResponse: (response: IAdvantagesResponse): UnwrapData<IAdvantagesResponse> => response.data,
      invalidatesTags: ['MainPageAdvantages'],
    }),
    /**
     * Удалить преимущество
     */
    deleteAdvantage: builder.mutation<void, { mainPageId: number; advantageId: number }>({
      query: ({ mainPageId, advantageId }) => ({
        method: 'DELETE',
        url: `/main_pages/${mainPageId}/advantages/${advantageId}`,
      }),
      invalidatesTags: ['MainPage', 'MainPageAdvantages'],
    }),
    /**
     * Изменить позицию преимущества
     */
    moveAdvantage: builder.mutation<
      UnwrapData<IMoveAdvantageResponse>,
      { mainPageId: number; advantageId: number; position: number }
    >({
      query: ({ mainPageId, advantageId, position }) => ({
        method: 'POST',
        url: `/main_pages/${mainPageId}/advantages/${advantageId}/move`,
        body: {
          data: {
            position,
          },
        },
      }),
      transformResponse: (response: IMoveAdvantageResponse): UnwrapData<IMoveAdvantageResponse> => response.data,
      invalidatesTags: ['MainPageAdvantages'],
    }),
  }),
});

export const {
  useGetAdvantagesQuery,
  useCreateAdvantageMutation,
  useUpdateAdvantageMutation,
  useDeleteAdvantageMutation,
  useMoveAdvantageMutation,
} = advantagesService;
